import React from 'react'

export const PermissionContext = React.createContext({
    hasCustomerAccess: false,
    username: '',
    permissions: [],
    organization_id: null,
    isAllowed: () => false,
    isAnyAllowed: () => false,
    isAllAllowed: () => false,
})
